import React, { useEffect } from "react"
import { useAppDispatch } from "../../app/store"
import { useNavigate, useSearchParams } from "react-router-dom"
import { token } from "../../features/Auth/authSlice"

type Props = {}

const getBookingIdFromPath = () => {
  const match = window.location.pathname.match(/pending-payments\/([^/?#]+)/)
  return match?.[1] || ""
}

export default function Reminderjobs({}: Props) {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const tokens = searchParams.get("token")
  const bookingId = searchParams.get("bookingId") || getBookingIdFromPath()
  const navigate = useNavigate()

  useEffect(() => {
    if (tokens) {
      dispatch(token(tokens as any))
    }
    navigate(
      bookingId
        ? `/dashboard/pending-payments/${bookingId}${tokens ? `?token=${tokens}` : ""}`
        : "/dashboard/my-bookings",
      { replace: true }
    )
  }, [tokens, bookingId, dispatch, navigate])

  return <>Loading.......</>
}

export function ActivePost({}: Props) {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const tokens = searchParams.get("token")
  const navigate = useNavigate()

  useEffect(() => {
    if (tokens) {
      dispatch(token(tokens as any))
    }
    navigate("/dashboard/", { replace: true })
  }, [tokens, dispatch, navigate])

  return <>Loading.......</>
}
